module.exports = __webpack_public_path__ + "static/media/6_3.fc329e14.png";